function ValidationError(message) {
  this.name = "ValidationError";
  this.message = message || "";
  this.stack = new Error().stack;
}
ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;

export default ValidationError;
